import {TextField as MuiTextField, TextFieldProps as MuiTextFieldProps} from '@mui/material'
import React from 'react'

export type TextFieldProps = MuiTextFieldProps

export function TextField({variant, ...rest}: TextFieldProps) {
  return <MuiTextField variant={variant ?? 'standard'} {...rest} />
}
